import { render, staticRenderFns } from "./PurchaseBillForm.vue?vue&type=template&id=36916e00"
import script from "./PurchaseBillForm.vue?vue&type=script&lang=js"
export * from "./PurchaseBillForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports